import { formatHtml } from "@trumpf/ux.common-storybook";
import { TeaserGatedContent } from "./teaser-gated-content.templates";

export default {
    title: "Website/Partial Templates/Teaser/Gated Content",
    render: TeaserGatedContent.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        headline: "Live Webinar",
        subline: "Wissen in Echtzeit",
        textAlignment: "center",
        text: "Unsere Live Webinare bieten exklusive Einblicke, interaktive Lernmöglichkeiten und direkten Austausch mit Experten, um Ihr Verständnis zu vertiefen und Ihre Fähigkeiten zu stärken.",
        shadow: true,
        icon: "info-rounded",
        iconSize: "50",
    },
    argTypes: {
        shadow: {
            control: "boolean",
        },
    },
};

export const Default = {};
